import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/auth.service';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { UtilsService } from 'src/app/services/utils.service';

export interface PopupDataInterface {
  title: string;
  message: string | null;
  closeable: boolean;
  haveMessage: boolean;
  note?: string | null;
  popupLink?: string | null;
  image?: string | null;
  video?: string | null | SafeResourceUrl;
}
export interface PopupInterface {
  agency: number;
  agencyName: string;
  createDate: string;
  file: string;
  id: number;
  mensaje: string;
  mostrarCerrar: string;
  nota: string;
  rol: number;
  rolName: string;
  state: string;
  titulo: string;
  urlVideo: null;
}

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent implements OnInit {
  //----------Inputs & Outputs----------
  @Input() popupData: any;
  @Output() changeHaveMessage: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  //----------Variables----------
  isImage: boolean = false;
  isVideo: boolean = false;
  isVideoUrl = false;
  actionButtons: boolean = false;
  showPopup: boolean | null = null;

  //----------Buttons----------
  buttonClose: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true,
  };
  buttonCancel: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Cancelar',
  };
  buttonLogout: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Cerrar sesion',
  };
  buttonAction: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Accion',
  };

  //----------Filtered popup Values----------
  popupDataFiltered: PopupDataInterface = {
    title: 'Default title',
    message: null,
    closeable: false,
    haveMessage: false,
    popupLink: '/panel',
  };

  constructor(
    private readonly router: Router,
    public utils: UtilsService,
    private readonly _domSanitizer: DomSanitizer,
    private readonly authService: AuthenticationService
  ) {}

  ngOnInit() {
    document.body.classList.add('ng-scope', 'disable-scroll');
    document.body.style.top = '0px';
  }
  ngOnChanges() {
    this.loadData();
  }

  loadData() {
    if (this.popupData) {
      this.isImage = false;
      this.isVideo = false;
      this.isVideoUrl = false;

      if (this.popupData.file) {
        this.isVideo = this.popupData.file.slice(-3) == 'mp4';
        this.isImage = this.popupData.file.slice(-3) != 'mp4';
      } else if (this.popupData.urlVideo) {
        this.isVideoUrl = true;
      }

      this.popupDataFiltered.title = this.popupData.titulo;
      this.popupDataFiltered.message = this.popupData.mensaje;
      this.popupDataFiltered.note = this.popupData.nota;
      this.popupDataFiltered.closeable = this.popupData.mostrarCerrar == 'SI';

      if (this.isImage) this.popupDataFiltered.image = this.popupData.file;
      if (this.isVideo) this.popupDataFiltered.video = this.popupData.file;
      if (this.isVideoUrl) {
        const urlVideo = this.popupData.urlVideo;
        this.popupDataFiltered.video =
          this._domSanitizer.bypassSecurityTrustResourceUrl(urlVideo);
      }
      this.showPopup = localStorage.getItem('showMessage') == 'true';
    }
  }
  logout() {
    this.authService.logout();
  }
  close(): void {
    if (this.popupDataFiltered.closeable) {
      if (this.popupDataFiltered) {
        this.changeHaveMessage.emit(false);
        localStorage.setItem('showMessage', 'false');
      }
    }

    // Se habilita nuevamente el scroll del body y se lleva al scroll original
    document.body.classList.remove('ng-scope', 'disable-scroll');
    document.body.style.top = '0px';
  }
  action(): void {
    if (this.popupDataFiltered) {
      this.popupDataFiltered.haveMessage = false;
      this.router.navigate(['/panel']);
    }

    // Se habilita nuevamente el scroll del body y se lleva al scroll original
    document.body.classList.remove('ng-scope', 'disable-scroll');
    document.body.style.top = '0px';
  }
}
